"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorWithLoading = exports.ErrorMessage = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var section_ids_1 = require("../../section-ids");
var Loading_1 = require("./Loading");
var ErrorMessage = function (_a) {
    var errorMetadata = _a.errorMetadata;
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    return (react_1.default.createElement(ErrorSection, { alertLevel: "error", id: section_ids_1.METER_READINGS_DATA_ERROR_SECTION_ID, "data-testid": section_ids_1.METER_READINGS_DATA_ERROR_SECTION_ID, errorMetadata: errorMetadata }));
};
exports.ErrorMessage = ErrorMessage;
var ErrorWithLoading = function (_a) {
    var error = _a.error, isFetching = _a.isFetching;
    return (isFetching ? react_1.default.createElement(Loading_1.Loading, null) : react_1.default.createElement(exports.ErrorMessage, { errorMetadata: { error: error } }));
};
exports.ErrorWithLoading = ErrorWithLoading;
